import { Stack } from '@mui/material';
import { APIKeys } from './APIKeys';
import { SSHKeys } from './SSHKeys';

export const KeysTab = () => {
  return (
    <Stack sx={{ my: 7, gap: 10 }}>
      <SSHKeys />
      <APIKeys />
    </Stack>
  );
};
